import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import { twMerge } from 'tailwind-merge';

interface AdultBadgeNewIconProps extends NewIconProps {
  opacity?: number;
  border?: boolean;
}

export const AdultBadgeIcon = ({
  className,
  color = Color.Gray500,
  opacity = 1,
  border = false,
}: AdultBadgeNewIconProps) => (
  <svg
    className={twMerge('size-[16px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="2" fill={color} fillOpacity={opacity} />
    <path
      d="M6.211 4.30083H5.01404L3.29999 5.47017V6.66976L4.91828 5.58106H4.95658V11.5991H6.211V4.30083Z"
      fill="white"
    />
    <path
      d="M9.96506 4.20002C8.42816 4.18994 7.40835 5.2736 7.40835 6.7C7.41314 8.08103 8.37071 9.07397 9.61076 9.06893C10.372 9.07397 11.0423 8.69595 11.3918 8.06087H11.4684C11.4589 9.6284 10.8939 10.5608 9.88846 10.5608C9.26125 10.5608 8.83513 10.1929 8.71064 9.61328H7.47538C7.62859 10.8229 8.55265 11.7 9.88846 11.7C11.5929 11.7 12.675 10.2433 12.675 7.72821C12.6702 5.06191 11.32 4.2101 9.96506 4.20002ZM8.62446 6.66976C8.61489 5.88851 9.19422 5.26352 9.97464 5.25848C10.7503 5.26352 11.3152 5.91875 11.3152 6.65968C11.32 7.41572 10.7263 8.07095 9.95549 8.07095C9.17985 8.07095 8.62446 7.45604 8.62446 6.66976Z"
      fill="white"
    />
    {border ? (
      <rect
        x="0.25"
        y="0.25"
        width="15.5"
        height="15.5"
        rx="1.75"
        stroke="white"
        strokeOpacity="0.3"
        strokeWidth="0.5"
      />
    ) : (
      <rect x="0.25" y="0.25" width="15.5" height="15.5" rx="1.75" />
    )}
  </svg>
);

export const AdultCoverBadgeIcon = () => <AdultBadgeIcon color={Color.Black} opacity={0.5} border />;
